import React, { useContext, useState, useRef } from 'react';
import uuid from 'uuidv4';
import { PokedexContext } from '../../Data/Context/pokemonData';
import pokemonTypes from '../../Data/pokemonTypes.js'
import { BuildContext } from '../../Data/Context/buildData';
import Alert from './alert'
import { useNavigate } from "react-router-dom";
import { LanguageContext } from '../../Data/Context/languageContext';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import { AppConfigContext } from '../../Config/App';

let counter = 0

const SearchByType = ({ dismiss, teammate, isHomepage }) => {
    const type_1 = useRef();
    const type_2 = useRef();
    const { fetchByType, pokemonList, fetchPokemon } = useContext(PokedexContext);
    const [isSearching, setIsSearching] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const { updateTeammate } = useContext(BuildContext);
    const [type_1_selected, setType_1_selected] = React.useState('');
    const [type_2_selected, setType_2_selected] = React.useState('');
    const navigate = useNavigate();
    const { t } = useContext(LanguageContext);
    const { uri_segment, navigate_to } = useContext(AppConfigContext);
    const { editingID } = useParams();

    function onSelectType(type) {
        if (counter === 0) {
            setType_1_selected(type);
            type_1.current = type;
            fetchByType(type_1.current);
        } else if (counter === 1) {
            setType_2_selected(type);
            type_2.current = type;
            fetchByType(type_1.current, type_2.current);
        } else {
            setType_1_selected(type)
            setType_2_selected();
            type_1.current = type;
            type_2.current = '';
            fetchByType(type_1.current);
            counter = 0;
        }
        setIsSearching(true);
        counter++;
    }

    function onSearch() {
        if (pokemonList.length === 0) {
            clearSelection();
            setShowResult(false);
        } else
            setShowResult(true);
    }

    function onPokemonSelect(name, id) {
        if (uri_segment() === "new-build" || editingID) {
            fetchPokemon(id);
            clearSelection();
        } else {
            navigate(navigate_to("builds/" + name.replaceAll(" ", "-").toLowerCase()));
        }
    }

    function clearSelection() {
        setShowResult(false)
        type_1.current = '';
        type_2.current = '';
        counter = 0;
        setType_1_selected();
        setType_2_selected();
        setIsSearching(false);
    }

    function onUpdateTeammate(pokemonID) {
        updateTeammate(pokemonID);
        clearSelection();
    }

    return (
        <>
            <div className="col search-by-types">
                {showResult
                    ?
                    <div className="search-result">
                        <div className="list-group">
                            <>
                                {teammate
                                    ?
                                    pokemonList.map((pokemon) => (
                                        <li onClick={() => onPokemonSelect(pokemon.name.pokeland, pokemon.id)} key={uuid()} data-bs-dismiss={isHomepage ? '' : 'offcanvas'} aria-label="Close" className="list-group-item list-group-item-action">
                                            {pokemon.name.pokeland}
                                        </li>
                                    ))
                                    :
                                    pokemonList.map((pokemon) => (
                                        <li onClick={() => onUpdateTeammate(pokemon.id)} key={uuid()} data-bs-dismiss={dismiss} aria-label="Close" className="list-group-item list-group-item-action">
                                            {pokemon.name.pokeland}
                                        </li>
                                    ))
                                }
                            </>
                        </div>
                    </div>
                    :
                    <>
                        <h4 className="text-center">{t("search_type")}</h4>
                        <div className='text-center'>
                            {
                                pokemonTypes.map((type) => (
                                    <span key={uuid()}>
                                        {(type_1_selected && type_1_selected === type) || (type_2_selected && type_2_selected === type)
                                            ?
                                            <button key={uuid()} onClick={() => onSelectType(type)} className={`iconType type-${type} type-selected`}>{t(type)}</button>
                                            :
                                            <button key={uuid()} onClick={() => onSelectType(type)} className={`iconType type-${type}`}>{t(type)}</button>
                                        }
                                    </span>
                                ))
                            }

                            {(pokemonList.length === 0) &&
                                <div className='container mt-4'>
                                    <Alert>
                                        {parse(t("no_pokemon_found"))}
                                    </Alert>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
            <div className='text-center mt-4'>
                {isSearching &&
                    <div className='d-flex justify-content-around flex-column d-grid gap-3'>
                        <button onClick={() => onSearch()} className='btn box searchByTypeBtn box-primary mx-2'>{t("search")} <i className={"fa-solid fa-magnifying-glass"}></i></button>
                        <button onClick={() => clearSelection()} className='btn box searchByTypeBtn box-danger mx-2'>{t("clear")} <i className="fa-solid fa-rotate-left"></i></button>
                    </div>
                }
            </div>
        </>
    );
}
export default React.memo(SearchByType);